import { takeLatest, put, call, fork } from "redux-saga/effects";
import PaymentProgramService from "services/payment-program-service";
import {
    fetchedPayProCaseNotes,
    failedFetchPayProCaseNotes,
} from "actions/paypro-case-note-actions";

import { PAYPRO_CASE_NOTE_ACTIONS } from "constants/actions";

function* fetchCaseNotesHandler({ payload: { action_details_id } }) {
    try {
        const { data, error } = yield call(PaymentProgramService.fetchPayProCaseNote, action_details_id);

        if (!error) {
            yield put(fetchedPayProCaseNotes(action_details_id, data));
        } else {
            yield put(failedFetchPayProCaseNotes(action_details_id, error));
        }
    } catch(error) {
        yield put(failedFetchPayProCaseNotes(action_details_id, error));
    }
}

export default fork(function*() {
    yield takeLatest(PAYPRO_CASE_NOTE_ACTIONS.FETCH_PAYPRO_CASE_NOTES, fetchCaseNotesHandler);
});
